query StoryList($site: [String] = "nl", $relatedToEntries: [EntryRelationCriteriaInput], $limit: Int, $offset: Int) {
    entries(
    site: $site,
    section: "stories",
    relatedToEntries: $relatedToEntries,
    limit: $limit,
    offset: $offset,
    orderBy: "dateCreated DESC"
    ) {
        ... on story_Entry {
            title
            uri

            contentHero {
                
                    ... on contentHeroBlock_Entry {
                        description
                        image {
                            id
                            url
                            alt
                            title
                            width
                            height
                            w222: url @transform(width: 222, format: "webp", mode: "crop")
                            w222_avif: url @transform(width: 222, format: "avif", mode: "crop")
                            w313: url @transform(width: 313, format: "webp", mode: "crop")
                            w313_avif: url @transform(width: 313, format: "avif", mode: "crop")
                            w444: url @transform(width: 444, format: "webp", mode: "crop")
                            w444_avif: url @transform(width: 444, format: "avif", mode: "crop")
                            w666: url @transform(width: 666, format: "webp", mode: "crop")
                            w666_avif: url @transform(width: 666, format: "avif", mode: "crop")
                        }
                    }
                
            }
        }
    },
    entryCount(
    site: $site,
    section: "stories",
    relatedToEntries: $relatedToEntries
    )
}
